import type { MediaItem } from "@gooner/shared";
import { useSession } from "../../lib/session";
import { AuthModal } from "./AuthModal";
import { FapCrownBursts, FapCrownCircle, useFapCrown } from "../../display/RegionFapOverlay";

/**
 * The fap crown on the Goon Fuel video: the SAME crown as a screen's regions (useFapCrown +
 * FapCrownCircle), so it shows how many people have fapped the clip, fills gold once you
 * have, and taps the same way, through the same memo. Only its size and its corner are its
 * own. Rendered inside the (relative) video stage.
 */
export function FapBar({ clip }: { clip: MediaItem }) {
  const signedIn = useSession((s) => !!s.user);
  const crown = useFapCrown({ current: clip, signedIn, surface: "fapbar" });

  return (
    <>
      <div className="absolute bottom-3 right-3 z-20">
        <FapCrownCircle
          crown={crown}
          size="player"
          className="relative shadow-lg hover:scale-110"
          onClick={() => crown.fap()}
          title={!signedIn ? "Sign in to fap" : "Fap — save to your library"}
        />
      </div>

      {/* Floating-crown bursts, rising from the crown's corner */}
      <FapCrownBursts bursts={crown.bursts} size={26} z="z-20" />

      {crown.authOpen && (
        <AuthModal initialMode="register" reason="Create a free account to fap this clip." onClose={crown.closeAuth} />
      )}
    </>
  );
}
